import EnvironmentConfig from '../interfaces/EnvironmentConfig'

const production: EnvironmentConfig = {
    dashboardUrl: 'https://dashboard-preprod.casaretail.in',
    ruleServerUrl: 'https://api-preprod.casa.ajira.tech',
    apiServerUrl: 'https://api-preprod.customerstudio.ajira.tech',
    redmineUrl: 'https://redmine.casaretail.ai',
    casaWebAppUrl: 'https://web.casa.ajira.tech',
    onboardingDashboardUrl: 'https://onboarding.casaretail.ai',
    casaEcomUrl: 'https://ecom.casa.ajira.tech',
    casaBeatUrl: 'https://beat-api.casa.ajira.tech',
    turnedOffFeatures: [],
    ruleUiUrl: 'https://rules.casa.ajira.tech',
    nifiUrl: 'https://dataflow.casaretail.ai/connector-test',
    ruleServiceToken: 'Soop1kY7.WOW,2mR%qK[dGIi Y|s6+zteZ5{]:)>-%1j7~%q_r:,+n`(--F2^#+@',
    keycloakConfig: {
        url: `https://auth.casaretail.ai`,
        realm: `casa`,
        clientId: `casa_dashboard`,
    },
}   

export default production
